export function initDeptGrouping() {
  const listWrapper = document.querySelector('.careers_col-list-wrap .w-dyn-items');
  if (!listWrapper) return;

  const items = listWrapper.querySelectorAll(':scope > .w-dyn-item');
  if (!items.length) return;

  // Group items by department
  const departments = {};
  const departmentOrder = [];

  items.forEach((item) => {
    const filterEl = item.querySelector('[job-department]');
    const dept = filterEl ? filterEl.getAttribute('job-department') : 'Other';

    if (!departments[dept]) {
      departments[dept] = [];
      departmentOrder.push(dept);
    }
    departments[dept].push(item);
  });

  // Clear wrapper
  items.forEach((item) => listWrapper.removeChild(item));

  // Re-append grouped with headers
  departmentOrder.forEach((dept) => {
    const header = document.createElement('h3');
    header.className = 'careers-jobs-dpt-title';
    header.textContent = dept;
    listWrapper.appendChild(header);

    departments[dept].forEach((item) => listWrapper.appendChild(item));
  });
}
